module.exports = __webpack_public_path__ + "static/media/folder-icon.f3cea7fc.svg";